import { render, staticRenderFns } from "./transmodel-edit.vue?vue&type=template&id=97b06ec6&scoped=true&"
import script from "./transmodel-edit.vue?vue&type=script&lang=js&"
export * from "./transmodel-edit.vue?vue&type=script&lang=js&"
import style0 from "./transmodel-edit.vue?vue&type=style&index=0&id=97b06ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b06ec6",
  null
  
)

export default component.exports